module.exports = __webpack_public_path__ + "static/media/malina.b3ca1651.png";